/*French (France) locale*/
webix.i18n.locales["fr-FR"] = {
	groupDelimiter:" ",
	groupSize:3,
	decimalDelimiter:",",
	decimalSize:2,
	dateFormat:"%d/%n/%Y",
	timeFormat:"%H:%i",
	longDateFormat:"%l %j %F %Y",
	fullDateFormat:"%l %j %F %Y %H:%i",
	am:null,
	pm:null,
	price:"{obj} €",
	priceSettings:{
		groupDelimiter:" ",
		groupSize:3,
		decimalDelimiter:",",
		decimalSize:2
	},
	calendar:{
		monthFull:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],
		monthShort:["Janv.","Févr.","Mars","Avr.","Mai","Juin","Juil.","Août","Sept.","Oct.","Nov.","Déc."],
		dayFull:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],
		dayShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."]
	}
};
